import * as React from 'react';

import MoveCopy16 from './MoveCopy16';

export const moveCopy16 = () => <MoveCopy16 />;

export default {
    title: 'Icon/Line/MoveCopy16',
    component: MoveCopy16,
    parameters: {
        notes: "`import MoveCopy16 from 'box-ui-elements/es/icon/line/MoveCopy16';`",
    },
};
